import { WorkspaceService } from '@affine/core/modules/workspace';
import { useService } from '@toeverything/infra';
import type { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import {
  FEATURE_KEY_COLLECTIONS,
  FEATURE_KEY_TAGS,
} from './product-feature-gates';
import { useFeatureGate } from './use-feature-gate';

export function useCollectionsFeatureEnabled() {
  const { isFeatureAllowed } = useFeatureGate();
  return isFeatureAllowed(FEATURE_KEY_COLLECTIONS);
}

export function useTagsFeatureEnabled() {
  const { isFeatureAllowed } = useFeatureGate();
  return isFeatureAllowed(FEATURE_KEY_TAGS);
}

function WorkspaceAllRedirect() {
  const workspace = useService(WorkspaceService).workspace;
  return <Navigate to={`/workspace/${workspace.id}/all`} replace />;
}

export function CollectionsFeatureGuard({ children }: PropsWithChildren) {
  return useCollectionsFeatureEnabled() ? (
    <>{children}</>
  ) : (
    <WorkspaceAllRedirect />
  );
}

export function TagsFeatureGuard({ children }: PropsWithChildren) {
  return useTagsFeatureEnabled() ? <>{children}</> : <WorkspaceAllRedirect />;
}
